<template>
  <div v-if="orderId && album" style="margin-bottom:150px">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title class="font-weight-medium">Album</v-toolbar-title>
    </v-toolbar>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="3" v-for="image in album" :key="image.id">
                    <meero-image :orderId="orderId" :image="image"></meero-image>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-card
      style="    position: fixed;
    bottom: 0px;
    left: 270px;
    height:150px;
    right: 0;"
    >
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <h3 class="subtitle">
                <span class="orange--text text--darken-1">{{photoSelected}}</span>
                / {{photoInPackage}} photos
              </h3>
              <v-btn color="primary" class="mt-4 themed" @click="send()">Télécharger les photos</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <h3 class="subtitle">Total: {{price?$format.money(price):'Inclus'}}</h3>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum saepe, laborum explicabo illum quia</p>
              <v-checkbox v-model="terms" label="J'accepte les conditions de ventes"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MeeroImage from "../../components/orders/MeeroImage";
export default {
  components: {
    MeeroImage
  },
  data: () => ({
    orderId: null,
    terms: false
  }),
  computed: {
    ...mapGetters("album", [
      "album",
      "photoSelected",
      "photoInPackage",
      "price"
    ])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("order", ["get"]),
    ...mapActions("album", ["sendSelection", "getAlbum"]),
    initialize() {
      if (this.$route.params.id) {
        this.orderId = parseInt(this.$route.params.id);
        if (!this.album) {
          this.$router.push("/orders/" + this.orderId);
        }
      } else {
        this.$router.push("/orders");
      }
    },
    send() {
      this.sendSelection(this.orderId).then(() => {
        this.getAlbum(this.orderId);
      });
    }
  }
};
</script>

<style lang="less">
.orderForm {
}
</style>